module.exports = __webpack_public_path__ + "img/DSC_2851-xs.189e4d2b.png";